module.exports = __webpack_public_path__ + "img/addPage.2e4917c3.svg";